<div class="mc-avatar-tooltip-container" [matTooltip]="commitId$ | async" [matTooltipDisabled]="disabledTooltip || !(commitId$ | async)">
  <div *ngIf="showAvatar" class="mc-avatar-container">
    <mat-icon class="mc-avatar-icon" fontSet="project-titan" fontIcon="icon-commit-horizontal"></mat-icon>
  </div>
  <ng-container *ngIf="showName && (!isLink() || isNameDisabled()); else link">
    <span class="mc-avatar-name">{{ commitId$ | async }}</span>
  </ng-container>
  <ng-template #link>
    <a href="#" class="mc-avatar-name" [routerLink]="routeCommands">{{ commitId$ | async }}</a>
  </ng-template>
</div>